import React from "react";

import "./SidePanel.scss";

import { reportTypes } from "../../store/reducers/reports";

import ReportsSidePanelTypes from "./SidePanel/Types";
import ReportsSidePanelStores from "./SidePanel/Stores";
import ReportsSidePanelStoreAttributes from "./SidePanel/StoreAttributes";

const ReportsSidePanel = (props) => {
  const { type, stores, selectedStores, selectedAttributes } = props;
  return (
    <div className="reports-panel">
      <ReportsSidePanelTypes />
      {(type === reportTypes.compareStores.value ||
        type === reportTypes.analyzeDailyPatterns.value ||
        type === reportTypes.analyzeRecentTrends.value) && (
        <ReportsSidePanelStores
          type={type}
          stores={stores}
          selectedStores={selectedStores}
        />
      )}
      {((type === reportTypes.compareStores.value &&
        selectedStores.length > 1) ||
        (type === reportTypes.analyzeDailyPatterns.value &&
          selectedStores.length > 0) ||
        (type === reportTypes.analyzeRecentTrends.value &&
          selectedStores.length > 0)) && (
        <ReportsSidePanelStoreAttributes
          type={type}
          selectedAttributes={selectedAttributes}
        />
      )}
    </div>
  );
};

export default React.memo(ReportsSidePanel);
